import { alpha, Button, styled, Typography } from '@mui/material';
import { MdSource } from 'react-icons/md';

export const RootStyled = styled('div')({
  padding: '12px 20px',
});

export const HeaderPageStyled = styled('div')(({ theme }) => ({
  marginTop: theme.spacing(2),
  display: 'flex',
  justifyContent: 'space-between',
}));

export const CompanyNameStyled = styled(Typography)({
  display: 'flex',
  flexDirection: 'column',
  gap: 32,
  marginBottom: 16,
  fontSize: '24px',
});

export const UploadContainerStyled = styled('div')({
  display: 'flex',
  justifyContent: 'flex-end',
  gap: 12,
  marginTop: 25,
  marginRight: 30,
  width: '30rem',
});

export const LoaderContainerStyled = styled('div')({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
});

export const BtnFolderStyled = styled(Button)(({ theme }) => ({
  color: theme.palette.global.white,
  fontFamily: theme.typography.button,
  height: 40,
  width: 210,
  fontSize: '12px',
}));

export const LoadingProgressStyled = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  width: '90vw',
  height: '50vh',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 16,
});

export const ContainerFolderNameStyled = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  fontSize: '12px',
  gap: 5,
  '& .enable': {
    backgroundColor: alpha(theme.palette.global.lightgray, 0.1),
    padding: 2,
    borderRadius: 5,
    cursor: 'pointer',
  },
  '& .folderName': {
    color: theme.palette.global.lightgray,
  },
}));

export const DefaultPageStyled = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  marginTop: 80,
  '& p': {
    color: theme.palette.global.lightgray,
    marginBottom: 40,
  },
}));

export const IconStyled = styled(MdSource)(({ theme }) => ({
  color: alpha(theme.palette.global.lightgray, 0.5),
  fontSize: 150,
}));
